import styled from 'styled-components'

import { ReactComponent as CrownSVG } from 'assets/images/crown.svg'
import { ContainerStatusAssignment } from 'pages/institutionDetails/styled'

export const MembersStepWrapper = styled.div`
  & > button {
    margin: 0 auto;
  }
`

export const ContainerButtons = styled.div`
  width: 500px;
  margin: 0 auto;

  button {
    width: 100%;

    &:first-of-type {
      margin-bottom: ${({ theme }) => theme.spacings[6]};
    }
  }
`

export const AdminIcon = styled(CrownSVG)`
  color: ${({ theme }) => theme.colors.sand};
  width: ${({ theme }) => theme.fontSizes.md};
`

export const IconDisabled = styled.span`
  color: ${({ theme }) => theme.colors.pinkishGrey};
  cursor: not-allowed;
`

export const Main = styled(ContainerStatusAssignment)`
  background: ${({ theme }) => theme.colors.blueLight};

  label {
    color: ${({ theme }) => theme.colors.blue};
  }
`

export const OtherAssignment = styled(ContainerStatusAssignment)`
  background: ${({ theme }) => theme.colors.warningLight};

  label {
    color: ${({ theme }) => theme.colors.warning};
  }
`
